import React from 'react';

import quoteStyles from './activityCard.module.css';

const Quote = ({title, company_name, description, dates}) => {
  return (
    <div className={quoteStyles.cardWrapper}>

    <div className={quoteStyles.card}>
      {dates}
      <div className={quoteStyles.dates}>
      </div>
    </div>

    <div className={quoteStyles.header}>
      <div className={quoteStyles.title}>{title}</div>
      <span className={quoteStyles.bukino}> @ </span>
      <div className={quoteStyles.company}>{company_name}</div>
    </div>

    <div className={quoteStyles.description}> {description} </div>

    </div>
  )
}

export default Quote;